import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "../Button/Button";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { RUTAS } from "../../rutas";
import { setShowNuevasCapacitacionesPresenciales } from "../../Slices/uiSlice";
import { useMutation } from "Hooks/useMutation";
import {
  getMisCapacitacionesPresenciales as getCapacitaciones,
  updateParticipanteMostrado,
} from "../../Services/mis_capacitaciones_presenciales_service";
import { storageService } from "../../Services/storage_service";
import "./NuevasCapacitacionesPresenciales.scss";

export const NuevasCapacitacionesPresenciales = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const open = useSelector(
    (state) => state.ui.showNuevasCapacitacionesPresenciales
  );
  const { mutate: fetchCapacitaciones } = useMutation(getCapacitaciones);
  const { mutate: updateCapacitacionesMostradas } = useMutation(
    updateParticipanteMostrado
  );

  const handleClose = () => {
    const user = storageService.getItem("user");

    fetchCapacitaciones(user?.usuario).then((capacitaciones) => {
      const capacitacionesNoMostradas =
        capacitaciones?.filter((cap) => !cap.mostrado) || [];
      const idsParticipantes = capacitacionesNoMostradas.map(
        (cap) => cap.idParticipante
      );

      if (idsParticipantes.length > 0) {
        updateCapacitacionesMostradas(idsParticipantes);
      }
    });

    dispatch(setShowNuevasCapacitacionesPresenciales(false));
  };

  const handleVerCapacitaciones = () => {
    navigate(RUTAS.MIS_CAPACITACIONES_PRESENCIALES);
    handleClose();
  };

  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      className="nuevas-capacitaciones-dialog"
    >
      <DialogTitle className="nuevas-capacitaciones-dialog__title">
        ¡Nuevas capacitaciones!
      </DialogTitle>
      <DialogContent>
        <p className="nuevas-capacitaciones-dialog__description">
          Se han habilitado nuevas capacitaciones presenciales para ti. Haz clic
          en <strong>“Acceder”</strong> para consultarlas y obtener tus
          diplomas.
        </p>
      </DialogContent>
      <DialogActions>
        <div className="nuevas-capacitaciones-dialog__actions">
          <Button onClick={handleClose} size="medium" variant="secundario">
            Cerrar
          </Button>
          <Button onClick={handleVerCapacitaciones} autoFocus size="medium">
            Acceder
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};
